import React, { useEffect, useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import ProSVGIcons from './ProSVGIcons'
import Button from './Button'
import { useLanguage } from '../../hooks/useLanguage'


const ProPrivacy = () => {
  const { lang } = useLanguage()

  return (
    <>

      {lang === 'EN' ? <div className='container mx-auto'>
        <h1 className='text-center text-4xl py-20'>Notices Based on the Specified Commercial Transactions Law</h1>
        <table className='table-auto w-full border-collapse border border-gray-500'>
          <thead>
            <tr className='bg-gray-200'>
              <th className='border border-gray-400 px-4 py-2 text-gray-800'>Item</th>
              <th className='border border-gray-400 px-4 py-2 text-gray-800'>Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>Seller</td>
              <td className='border border-gray-400 px-4 py-2'>1F8 Corporation</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>Person in Charge</td>
              <td className='border border-gray-400 px-4 py-2'>CEO Kwa Tran</td>
            </tr>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>Address</td>
              <td className='border border-gray-400 px-4 py-2'>1-50-1511 Miyamachi, Fuchu, Tokyo 183-0023, Japan</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>Phone Number</td>
              <td className='border border-gray-400 px-4 py-2'>Phone: (050) 5806-6840 ※ Please contact us by email.</td>
            </tr>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>Email Address</td>
              <td className='border border-gray-400 px-4 py-2'>hello@1f8.dev</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>Sales URL</td>
              <td className='border border-gray-400 px-4 py-2'><a href='https://1f8.co.jp/' className='text-blue-500'>https://1f8.co.jp/</a></td>
            </tr>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>Product Prices</td>
              <td className='border border-gray-400 px-4 py-2'>Please refer to each product page.</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>Additional Costs Other than Products</td>
              <td className='border border-gray-400 px-4 py-2'>None</td>
            </tr>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>Payment Methods</td>
              <td className='border border-gray-400 px-4 py-2'>Bank Transfer, Credit Card Payment</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>Payment Timing</td>
              <td className='border border-gray-400 px-4 py-2'>Immediate payment at the time of purchase</td>
            </tr>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>Product Delivery Time</td>
              <td className='border border-gray-400 px-4 py-2'>Varies by product, please check at the time of purchase.</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>Returns and Exchanges</td>
              <td className='border border-gray-400 px-4 py-2'>Please refer to the refund policy on the site.</td>
            </tr>
          </tbody>
        </table>
      </div>
        :
      <div className='container mx-auto pb-10'>
        <h1 className='text-center text-4xl pb-40 pt-20'>特定商品取引法に基づく表記</h1>
        <table className='table-auto w-full border-collapse border border-gray-500'>
          <thead>
            <tr className='bg-gray-200'>
              <th className='border border-gray-400 px-4 py-2 text-gray-800'>項目</th>
              <th className='border border-gray-400 px-4 py-2 text-gray-800'>内容</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>販売業者</td>
              <td className='border border-gray-400 px-4 py-2'>株式会社 1F8</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>責任者</td>
              <td className='border border-gray-400 px-4 py-2'>代表取締役 Kwa Tran</td>
            </tr>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>住所</td>
              <td className='border border-gray-400 px-4 py-2'>〒183-0023 東京都府中市宮町1-50-1511</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>電話番号</td>
              <td className='border border-gray-400 px-4 py-2'>電話番号: (050) 5806-6840 ※ ご連絡はメールでお願いたします。</td>
            </tr>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>メールアドレス</td>
              <td className='border border-gray-400 px-4 py-2'>hello@1f8.dev</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>販売URL</td>
              <td className='border border-gray-400 px-4 py-2'><a href='https://1f8.co.jp/'className='text-blue-500'>https://1f8.co.jp/</a></td>
            </tr>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>商品の販売価格</td>
              <td className='border border-gray-400 px-4 py-2'>各商品ページをご参照ください。</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>商品以外の必要料金</td>
              <td className='border border-gray-400 px-4 py-2'>銀行振込の場合は振込手数料、消費税</td>
            </tr>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>支払方法</td>
              <td className='border border-gray-400 px-4 py-2'>銀行振込、クレジットカード決済</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>支払時期</td>
              <td className='border border-gray-400 px-4 py-2'>商品ご購入時の即時決済</td>
            </tr>
            <tr>
              <td className='border border-gray-400 px-4 py-2'>商品の引渡時期</td>
              <td className='border border-gray-400 px-4 py-2'>商品によって異なりますので、購入時の商品をご確認くだい。</td>
            </tr>
            <tr className='bg-gray-100'>
              <td className='border border-gray-400 px-4 py-2'>返品・交換</td>
              <td className='border border-gray-400 px-4 py-2'>商品の性質上、制作過程中盤以降の返品や料金お支払い後の返品はお受けできません。
                商品に欠陥がある場合のみ交換が可能ですのでご連絡ください。</td>
            </tr>
          </tbody>
        </table>
      </div>}
    </>
  )

}


export default ProPrivacy




